import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {useSlide} from '../press-release-carousel/use-slide';
import {Indicator} from '../press-release-carousel/indicator';
import styles from './carousel.module.css';
import {Slide, type StoryProps} from './slide';

type Props = {
  readonly stories: StoryProps[];
};

export function LatestStoriesCarousel({stories}: Props) {
  const {
    back,
    forward,
    slideOnClickDot,
    currentSlidePage,
    total,
    slidePositionX,
  } = useSlide(stories.length);

  return (
    <div className={styles.carousel}>
      <Indicator
        length={total}
        currentIndex={currentSlidePage}
        slideOnClickDot={slideOnClickDot}
      />
      {currentSlidePage > 1 && (
        <button
          type='button'
          className={clsx(
            styles.arrow,
            styles.arrowLeft,
            isContainerQueryAvailable() ? styles.arrowCQ : styles.arrowFallback,
          )}
          aria-label='前のページへ進む'
          onClick={back}
        >
          <svg
            width='13'
            height='23'
            viewBox='0 0 13 23'
            fill='none'
            aria-hidden='true'
          >
            <path
              d='M12 1.5L2 11.5677L11.8644 21.5'
              stroke='black'
              strokeWidth='2.00117'
              strokeMiterlimit='2'
            />
          </svg>
        </button>
      )}
      <div
        className={clsx(
          styles.sliderContainer,
          isContainerQueryAvailable()
            ? styles.sliderContainerCQ
            : styles.sliderContainerFallback,
        )}
      >
        <div
          className={clsx(
            styles.sliderWrapper,
            isContainerQueryAvailable()
              ? styles.sliderWrapperCQ
              : styles.sliderWrapperFallback,
          )}
        >
          <ul
            className={clsx(
              styles.slider,
              isContainerQueryAvailable()
                ? styles.sliderCQ
                : styles.sliderFallback,
            )}
            style={{transform: `translateX(-${slidePositionX}px)`}}
            data-testid='imageSlider'
          >
            {stories.map((story, index) => (
              <Slide
                key={story.id}
                title={story.title}
                hash={story.hash}
                smallThumbnailUrl={story.smallThumbnailUrl}
                postedAt={story.postedAt}
                currentIndex={currentSlidePage}
                slideNumber={index}
              />
            ))}
          </ul>
        </div>
      </div>
      {currentSlidePage < total && (
        <button
          type='button'
          className={clsx(
            styles.arrow,
            styles.arrowRight,
            isContainerQueryAvailable() ? styles.arrowCQ : styles.arrowFallback,
          )}
          aria-label='次のページへ進む'
          onClick={forward}
        >
          <svg
            width='13'
            height='23'
            viewBox='0 0 13 23'
            fill='none'
            aria-hidden='true'
          >
            <path
              d='M1 1.5L11 11.5677L1.13556 21.5'
              stroke='black'
              strokeWidth='2.00117'
              strokeMiterlimit='2'
            />
          </svg>
        </button>
      )}
    </div>
  );
}
